export default __webpack_public_path__ + "static/media/default.fb7d5049a02d85774cdc0f6dbd8318c0.png";